<template>
  <div v-bind="$attrs"><slot></slot></div>
</template>

<script>
export default {
  name: 'OutsideClickListener',
  mounted() {
    document.documentElement.addEventListener('click', this.handleClickAnywhere)
  },
  beforeDestroy() {
    document.documentElement.removeEventListener(
      'click',
      this.handleClickAnywhere
    )
  },
  methods: {
    handleClickAnywhere(e) {
      if (!this.$el.contains(e.target)) {
        this.$emit('clickoutside')
      }
    },
  },
}
</script>
